
import { defineComponent } from "vue";

export default defineComponent({
  name: "BaseModal",
  props: ["visible"],
});
